import axiosClient from '@clients/axiosClient';

export interface ICreateDisputeInputs {
    modality: string;
    dispute_due_to?: string;
    amount: number;
    arn?: string;
    comment?: string;
}

export interface ICreateDispute extends ICreateDisputeInputs {
    protocol?: string;
    transaction_date?: string;
    authorization_id?: number;
}

export interface IDisputeDetails {
    accountId: number;
    dataToSubmit: ICreateDispute;
}

export interface IGetDisputeDetails {
    authorizationId: number;
}

export type DisputeResponse = {
    account_id: number;
    authorization_id: number;
    comment: string;
    created_at: string;
    created_at_utc: string;
    dispute_reason: number;
    dispute_status: string;
    dispute_status_group: string;
    disputed_amount: number;
    id: number;
    is_network: boolean;
    metadata: string;
    modality: number;
    network_brand_type: string;
    network_return_reason_code: string;
    org_id: string;
    protocol: string;
    reversal_id: string;
    timeline: string;
    transaction_date: string;
    updated_at: string;
    updated_at_utc: string;
};

const disputes = () => {
    const client = axiosClient();

    return {
        async postCreateDispute({ accountId, dataToSubmit }: IDisputeDetails) {
            const { data } = await client.post(
                `/disputes/v1/networkauthorization-disputes`,
                { ...dataToSubmit },
                { headers: { 'x-account-id': accountId } },
            );
            return data;
        },
        async getDisputeDetails({ authorizationId }: IGetDisputeDetails) {
            const { data } = await client.get(
                `/disputes/v1/authorization-disputes/authorizations/${authorizationId}`,
            );
            return data;
        },
    };
};

export default disputes;
